import {getDefaultWorkspace} from './get-default-workspace';
import {setDefaultWorkspace} from './set-default-workspace';

export function setDefaultApplicationCompany(applicationId: string, companyId: number) {
  const defaultWorkspace = {...getDefaultWorkspace(), [applicationId]: companyId};
  setDefaultWorkspace(defaultWorkspace);
}
